import Radio from "backbone.radio";

import { TabController } from "common/controllers/tabController";
import { pazienHistory } from "common/components/pazienHistory";
import { UsersView } from "./users";

export const UsersController = TabController.extend({
    masterTabOptions: {
        name: "All users",
        view: UsersView,
        fragment: "administrator/users"
    },
    
    applicationViewOptions: {
        id: "users",
        name: "Users",
        hideDatePicker: true
    },
    
    channelName: "users",
    
    radioEvents: {
        "open:new:tab": "openNewTab"
    },
    
    getParentChannel() {
        return Radio.channel("main");
    },
    
    listAllUsers() {
        return this._makeTabbedView({ defaultTab: null }, ...arguments);
    },
    
    openNewTab({ merchant_ref, display_name }) {
        pazienHistory.navigateWithParams(`administrator/users/${merchant_ref}`);
        this.openChildTab({}, merchant_ref, display_name);
    },
    
    openChildTab(options, merchant_ref, display_name) {
        return this._makeTabbedView({
            tab: {
                name: display_name,
                newTab: true,
                view: UsersView,
                viewOptions: {
                    merchant_ref,
                    display_name
                }
            }
        }, ...arguments);
    }
});
